import { axiosRequest } from "../axios.config";

const ordersApi = {
  getCart: async () => {
    const url = "ShoppingCart";
    const response = await axiosRequest.get(url);
    return response;
  },
  deleteItemFromCart: async (data) => {
    const url = `ShoppingCart/?courseId=${data.itemId}`;
    const response = await axiosRequest.delete(url);
    return response;
  },
  addCourseToCart: async (data) => {
    const url = `ShoppingCart?courseId=${data.courseId}`;
    const response = await axiosRequest.post(url);
    return response;
  },
  handleCart: async (data) => {
    const url = `ShoppingCart?courseId=${data.id}`;
    const response = await axiosRequest.put(url, {
      courseId: data.id,
      isActive: data.isActive,
    });
    return response;
  },
  addOrder: async (data) => {
    const url = "Order";
    const response = await axiosRequest.post(url, data);
    return response;
  },
  getDetailOrder: async (id) => {
    const url = `Order?id=${id}`;
    const response = await axiosRequest.get(url);
    return response;
  },
};

export { ordersApi };
